import React, { useState, useRef, useEffect } from "react";
import { Typography } from "@mui/material";
import { ReactComponent as TooltipIcon } from "../../assets/icons/help-circle.svg";

const Tooltip = ({ text }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const iconRef = useRef(null);
  const popupRef = useRef(null);

  useEffect(() => {
    if (isOpen && iconRef.current && popupRef.current) {
      const iconRect = iconRef.current.getBoundingClientRect();
      const popupRect = popupRef.current.getBoundingClientRect();

      // Calculate position: center popup above icon with some padding
      const top = iconRect.top - popupRect.height - 8;
      const left = iconRect.left - popupRect.width + iconRect.width / 2;

      setPosition({ top: Math.max(8, top), left: Math.max(8, left) });
    }
  }, [isOpen]);

  return (
    <div className="tooltip">
      <div
        ref={iconRef}
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
      >
        <TooltipIcon className="tooltip__icon" />
      </div>
      {isOpen && (
        <div
          ref={popupRef}
          className="tooltip__popup"
          style={{
            position: "fixed",
            top: `${position.top}px`,
            left: `${position.left}px`,
          }}
        >
          <Typography variant="body1" className="tooltip__text">
            {text}
          </Typography>
        </div>
      )}
    </div>
  );
};

export default Tooltip;
